module.exports = __webpack_public_path__ + "img/big2-3.174d0457.jpg";